<template>
  <form
    id="program-form"
    ref="program-form"
    class="tw-max-w-full tw-flex-shrink-0 tw-mx-auto tw-mb-20 auth-card tw-flex tw-flex-wrap"
    method="post"
    action="/company-program/create"
    @submit.prevent="onSubmit"
  >
    <div class="tw-w-full tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <InputGroup
        :class="{ '--loading-data': loadingForm }"
        label="Program Logo"
        name="logo"
        type="file"
        placeholder="Program Logo"
        input-classes="tw-p-3"
        v-model="form.logo"
        :error="errors.logo"
      />
    </div>
    <div class="tw-w-full tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <InputGroup
        :class="{ '--loading-data': loadingForm }"
        label="Program Name"
        name="name"
        type="text"
        placeholder="Program Name"
        input-classes="tw-p-3"
        v-model="form.name"
        :error="errors.name"
      />
    </div>
    <div class="tw-w-full tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <QuillTextareaGroup
        :class="{ '--loading-data': loadingForm }"
        label="Program Description"
        instruct="Give a small description about the program"
        name="description"
        type="text"
        placeholder="name"
        input-classes="tw-p-3 focus:tw-bg-gray-100"
        v-model="form.description"
        :rows="4"
        :error="errors.description"
      />
    </div>
    <div class="tw-w-full tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <!-- SELECT GOAL IF GOALID IS NOT SET -->
      <SelectGroup
        :class="{ '--loading-data': loadingForm }"
        label="Program Type"
        name="type"
        nameKey="type"
        placeholder="type"
        input-classes="my-select--huge tw-bg-gray-200 tw-text-left"
        v-model="form.typeId"
        :options="programTypes"
        :reduce="type => type.id"
        :clearable="false"
        :error="errors.typeId"
      />
    </div>
    <div class="tw-w-1/2 tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <InputGroup
        label="Start date"
        name="start"
        type="date"
        placeholder="Start Date"
        input-classes="tw-p-1"
        v-model="form.start"
        :error="errors.start"
        class="tw-mr-1 tw-ml-3"
      />
    </div>
    <div class="tw-w-1/2 tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <InputGroup
        label="End date"
        name="end"
        type="date"
        placeholder="End Date"
        input-classes="tw-p-1"
        v-model="form.end"
        :error="errors.end"
        class="tw-mr-1 tw-ml-3"
      />
    </div>
    <div class="tw-w-1/2 tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <label class="tw-block tw-text-sm tw-mb-2 opacity-78 tw-text-left" for="color">
        Primary Color
      </label>
      <input
        class="tw-p-1 tw-w-full tw-rounded-sm tw-block tw-bg-gray-200 tw-outline-none transition hover:tw-bg-gray-200 focus:tw-bg-white tw-h-12"
        type="color"
        placeholder="Select Primary Color"
        name="color"
        v-model="form.color"
      >
    </div>
    <div class="tw-w-1/2 tw-mb-4 tw-flex-shrink-0 tw-px-1">
      <label class="tw-block tw-text-sm tw-mb-2 opacity-78 tw-text-left" for="color">
        Secondary Color
      </label>
      <input
        class="tw-p-1 tw-w-full tw-rounded-sm tw-block tw-bg-gray-200 tw-outline-none transition hover:tw-bg-gray-200 focus:tw-bg-white tw-h-12"
        type="color"
        placeholder="Select Primary Color"
        name="color2"
        v-model="form.color2"
      >
    </div>

    <div class="tw-w-full tw-flex-shrink-0 tw-px-1 tw-mb-4 tw-pt-10">
      <BaseButton
        type="submit"
        :class="[
          'tw-block tw-w-full md:tw-inline-block md:tw-w-auto tw-mb-4 tw-py-3 tw-px-8',
        ]"
        :text="btnText"
        :disabled="!canSubmit || btnDisabled"
      />
    </div>
  </form>
</template>

<script>
import QuillTextareaGroup from '@/components/QuillTextareaGroup.vue';
import InputGroup from '@/components/InputGroup.vue';
import SelectGroup from '@/components/SelectGroup.vue';

import form from '@/modules/formHelper';
import { toJsDate } from '@/modules/dataHelper';
import { generateFormData } from '@/modules/apiHelper';

export default {
  components: {
    QuillTextareaGroup,
    InputGroup,
    SelectGroup,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingForm: true,
      errorForm: undefined,
      btnText: 'Create Program',
      btnDisabled: false,
      errors: {},
      form: {
        typeId: undefined,
        logo: undefined,
        name: undefined,
        description: undefined,
        start: undefined,
        end: undefined,
        color: undefined,
        color2: undefined,
      },
      programTypes: [],
    };
  },
  computed: {
    canSubmit() {
      return form.isValidTextInput(this.form.name)
        && form.isValidTextInput(this.form.description)
        && !this.loadingForm
        && this.form.logo !== undefined
        && this.form.color !== undefined
        && this.form.color2 !== undefined
        && this.form.start !== undefined
        && this.form.end !== undefined
        && this.form.typeId !== undefined;
    },
  },
  methods: {
    async onSubmit() {
      if (!this.canSubmit) {
        this.$toasted.global.appError({
          errorMessage: 'You can\'t submit the form. Check for empty inputs',
        });

        console.warn('Cannot submit form... \n check for empty inputs');
        return false;
      }

      // signup!!
      this.btnDisabled = true;
      this.btnText = 'working...';

      const data = {
        ...(this.form),
        type: this.form.typeId,
        desc: this.form.description,
        start: this.$moment(toJsDate(this.form.start)).format('YYYY-MM-DD'),
        end: this.$moment(toJsDate(this.form.end)).format('YYYY-MM-DD'),
        companyid: this.company.id,
        file1: this.form.logo[0],
        logo: this.form.name,
        adminid: this.$store.state.User.id,
      };

      const result = await this.$store.dispatch('createCompanyProgram', generateFormData(data));

      if (result) {
        this.$toasted.success('Saved!', { duration: 1000 });
        this.$emit('created-success');
      } else {
        this.$toasted.global.appError({
          errorMessage: 'Creating program failed. Please try again later',
        });
      }

      this.btnDisabled = false;
      this.btnText = 'Create Program';

      return result;
    },

    async loadForm() {
      const programTypes = await this.$store.dispatch('getProgramTypes', []);

      if (programTypes) {
        this.programTypes = programTypes;
      } else {
        console.error('Error getting program types. \n getProgramTypes::', programTypes);
      }
    },
  },
  async created() {
    this.errors = { ...this.form };

    await this.$nextTick();
    await this.loadForm();
    await this.$nextTick();

    this.loadingForm = false;
  },
};
</script>

<style>

</style>
